export const riskMatrix = [
    { "sn": 1, "impact": 1, "likelihood": 1, "score": 1, "level": "Very Low" },
    { "sn": 2, "impact": 1, "likelihood": 2, "score": 2, "level": "Very Low" },
    { "sn": 3, "impact": 1, "likelihood": 3, "score": 3, "level": "Low" },
    { "sn": 4, "impact": 1, "likelihood": 4, "score": 4, "level": "Medium" },
    { "sn": 5, "impact": 1, "likelihood": 5, "score": 5, "level": "Medium" },
    { "sn": 6, "impact": 2, "likelihood": 1, "score": 2, "level": "Very Low" },
    { "sn": 7, "impact": 2, "likelihood": 2, "score": 4, "level": "Low" },
    { "sn": 8, "impact": 2, "likelihood": 3, "score": 6, "level": "Medium" },
    { "sn": 9, "impact": 2, "likelihood": 4, "score": 8, "level": "Medium" },
    { "sn": 10, "impact": 2, "likelihood": 5, "score": 10, "level": "High" },
    { "sn": 11, "impact": 3, "likelihood": 1, "score": 3, "level": "Low" },
    { "sn": 12, "impact": 3, "likelihood": 2, "score": 6, "level": "Medium" },
    { "sn": 13, "impact": 3, "likelihood": 3, "score": 9, "level": "Medium" },
    { "sn": 14, "impact": 3, "likelihood": 4, "score": 12, "level": "High" },
    { "sn": 15, "impact": 3, "likelihood": 5, "score": 15, "level": "Very High" },
    { "sn": 16, "impact": 4, "likelihood": 1, "score": 4, "level": "Medium" },
    { "sn": 17, "impact": 4, "likelihood": 2, "score": 8, "level": "Medium" },
    { "sn": 18, "impact": 4, "likelihood": 3, "score": 12, "level": "High" },
    { "sn": 19, "impact": 4, "likelihood": 4, "score": 16, "level": "Very High" },
    { "sn": 20, "impact": 4, "likelihood": 5, "score": 20, "level": "Extreme" },
    { "sn": 21, "impact": 5, "likelihood": 1, "score": 5, "level": "Medium" },
    { "sn": 22, "impact": 5, "likelihood": 2, "score": 10, "level": "High" },
    { "sn": 23, "impact": 5, "likelihood": 3, "score": 15, "level": "Very High" },
    { "sn": 24, "impact": 5, "likelihood": 4, "score": 20, "level": "Extreme" },
    { "sn": 25, "impact": 5, "likelihood": 5, "score": 25, "level": "Severe" }
  ];
  
  export const oppMatrix = [
    { "sn": 1, "passionRange": "1-50", "profitRange": "1-50", "comment": "Back Burner" },
    { "sn": 2, "passionRange": "1-50", "profitRange": "51-100", "comment": "Bread & Butter" },
    { "sn": 3, "passionRange": "51-100", "profitRange": "1-50", "comment": "Pie in the Slice" },
    { "sn": 4, "passionRange": "51-100", "profitRange": "51-100", "comment": "Just Do It" }
  ];
  